import React, { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import { Tooltip, Typography } from "@mui/material";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { useNavigate } from "react-router-dom";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  DownloadsanjeevaniReceiptData,
  DownloadsuvidhaReceiptData,
  GetSJNYAdminDepostRequestDashboard,
  DownloadSuvidhaApplicationForm,
  DownloadSanjeevaniApplicationForm,
} from "../../Helpers/APIEndPoints/EndPoints";
import OverflowTip from "../../Components/OverflowToolTip/OverflowToolTip";
import moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";
import {
  getActionEditForLoanDashboard,
  getStatusIdsForLoanDashboard,
} from "../../Pages/LoanApproval/Helpers/GridHelper";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import {
  SanjeevaniDepositStatus,
  SanjeevaniWithdrawStatus,
  SuvidhaDepositStatus,
  SuvidhaWithdrawStatus,
} from "../../Helpers/Enums/ApplicationStatus";
import { IDepositeGrid } from "./Grid/SanjeevaniGrid";
import { AppModules } from "../../Helpers/Enums/AppModules";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import axios from "axios";
import fileDownload from "js-file-download";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";

const SANReqGrid = (props: IDepositeGrid) => {
  const {
    searchText,
    setSearchText,
    activeTab,
    currentFilters,
    dataCount,
    setDataCount,
  } = props;
  const { appModule } = props;
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const navigate = useNavigate();
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [dashboardData, setDashboardData] = useState([]);

  useEffect(() => {
    if (activeTab != null) {
      getDashboardData();
    }
  }, [
    activeTab,
    start,
    sortColumn,
    sortDirection,
    searchText,
    currentFilters,
    appModule,
  ]);
  // console.log("current app module  " + appModule);

  const downloadDynForm = async (foundMemId, reqId) => {
    
    showLoader();
    let requestParams = {
      MemberId: foundMemId,
      RequestId: reqId,
    };
    let token = await fetchAuthToken();
    let fileNamePrefix = "";
    if (appModule === AppModules.SanjeevaniYojana) {
      fileNamePrefix = "SanjeevaniForm_";
    } else if (appModule === AppModules.SuvidhaYojna) {
      fileNamePrefix = "SuvidhaForm_";
    }
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url:
          appModule === AppModules.SanjeevaniYojana
            ? DownloadSanjeevaniApplicationForm
            : DownloadSuvidhaApplicationForm,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `${fileNamePrefix}${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.pdf`
        );

        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        notify(
          1,
          "Oops! Something went wrong. We're on it. Please try again later."
        );
       
      });
  };
  const handleNavigation = (
    id,
    currentStatus,
    RequestId,
    DocUrl,
    TypeOfTransactionId,
    reqId
  ) => {
    const path =
      appModule === AppModules.SanjeevaniYojana
        ? "/SanjivaniMenu"
        : "/SuvidhaMenu";
    navigate(path, {
      state: {
        Id: id,
        currentStatus: currentStatus,
        RequestId: RequestId,
        DocUrl: DocUrl,
        TypeOfTransactionId: TypeOfTransactionId,
        reqId: reqId,
      },
    });
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  //Columns
  const GridColumns = [
    //0
    {
      name: "MemberId",
      label: "MemberId",
      options: {
        display: false,
      },
    },
    //1
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    //2
    {
      name: "StatusId",
      label: "StatusId",
      options: {
        display: false,
      },
    },
    //3
    {
      name: "MemberNumber",
      label: "Member No",
      options: CommonCellOptions(),
    },
    //4
    {
      name: "Name",
      label: "Name",
      options: CommonCellOptions(),
    },
    //5
    {
      name: "Amount",
      label: "Amount",
      options: {
        ...CommonCellOptions(),
        display: activeTab.id === "Deposite-requests",
      },
    },
    //6
    {
      name: "FinalAmount",
      label: "Final Amount",
      options: {
        ...CommonCellOptions(),
        display: activeTab.id === "Withdraw-requests",
      },
    },
    //7
    {
      name: "Transactiondate",
      label: "Transaction Date",
      options: {
        ...CommonCellOptions(true),
        //display: context?.CurrentRoleId === RoleEnum.Admin,
        display: activeTab.id === "Deposite-requests",
      },
    },
    //8
    {
      name: "TransactionReferenceNo",
      label: "Transaction Ref No",
      options: {
        ...CommonCellOptions(),
        display: activeTab.id === "Deposite-requests",
      },
    },
    //9
    {
      name: "RequestId",
      label: "Request Id",
      options: {
        display: false,
      },
    },
    //10
    {
      name: "DocUrl",
      label: "DocUrl",
      options: {
        display: false,
      },
    },
    //11
    {
      name: "TypeOfTransactionId",
      label: "Type Of TransactionId",
      options: {
        display: false,
      },
    },
    // {
    //   name: "schemes",
    //   label: "No Of Schemes",
    //   options: {
    //     ...CommonCellOptions(),

    //     display: activeTab.id === "Withdraw-requests",
    //   },
    // },
    // {
    //   name: "ApplicationNo",
    //   label: "Application No",
    //   options: {
    //     ...CommonCellOptions(),

    //     display: activeTab.id === "Withdraw-requests",
    //   },
    // },
    //12
    {
      name: "Transactiondate",
      label: "Application Date",
      options: {
        ...CommonCellOptions(true),
        display: activeTab.id === "Withdraw-requests",
      },
    },
    //13
    {
      name: "Status",
      label: "Status",
      options: {
        display: true,
      },
    },
    //14 Deposite-req action
    {
      name: "Action",
      label: "Action",
      options: {
        display: activeTab.id === "Deposite-requests",
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          let reqId = tableMeta.rowData[1];
          const currentStatus = tableMeta.rowData[2];
          const RequestId = tableMeta.rowData[9];
          const DocUrl = tableMeta.rowData[10];
          const TypeOfTransactionId = tableMeta.rowData[11];

          const path =
            appModule === AppModules.SanjeevaniYojana
              ? "/SanjivaniMenu"
              : "/SuvidhaMenu";

          // Deposite pending
          if (
            currentStatus ===
              SanjeevaniDepositStatus.Deposit_Approval_Pending ||
            currentStatus === SuvidhaDepositStatus.SU_Deposit_Approval_pending
          ) {
            return (
              <>
                <div className="d-flex justify-content-start align-items-center">
                  <Tooltip title="Edit">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        e.preventDefault();

                        if (
                          context?.CurrentRoleId === RoleEnum.Admin ||
                          RoleEnum.Member
                        ) {
                          navigate(path, {
                            state: {
                              Id: id,
                              currentStatus: currentStatus,
                              RequestId: RequestId,
                              DocUrl: DocUrl,
                              TypeOfTransactionId: TypeOfTransactionId,
                              reqId: reqId,
                              // mode: "Edit",
                            },
                          });
                        }
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </a>
                  </Tooltip>
                  {/* <Tooltip title="Application Form" className="ml-2">
                    <a
                      onClick={() => {
                        downloadDynForm(id, RequestId);
                      }}
                    >
                      <i className="fa fa-download"></i>
                    </a>
                  </Tooltip> */}
                </div>
              </>
            );
          } else {
            return (
              <Tooltip title="view">
                <a
                  className="pr-3"
                  onClick={(e) => {
                    e.preventDefault();
                    if (
                      context?.CurrentRoleId === RoleEnum.Admin ||
                      RoleEnum.Member
                    ) {
                      navigate(path, {
                        state: {
                          Id: id,
                          currentStatus: currentStatus,
                          RequestId: RequestId,
                          DocUrl: DocUrl,
                          TypeOfTransactionId: TypeOfTransactionId,
                          reqId: reqId,
                          // mode: "View",
                        },
                      });
                    }
                  }}
                >
                  <i className="fas fa-eye"></i>
                </a>
              </Tooltip>
            );
          }
        },
      },
    },
    //15 Withdraw-requests Action
    {
      name: "Action",
      label: "Action",
      options: {
        display: activeTab.id === "Withdraw-requests",
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          let reqId = tableMeta.rowData[1];
          const currentStatus = tableMeta.rowData[2];
          const RequestId = tableMeta.rowData[9];
          const DocUrl = tableMeta.rowData[10];
          const TypeOfTransactionId = tableMeta.rowData[11];
          const finalAmtFromList = tableMeta.rowData[6];
          const path =
            appModule === AppModules.SanjeevaniYojana
              ? "/SanjivaniMenu"
              : "/SuvidhaMenu";
          // withdraw pending
          if (
            currentStatus ===
            SanjeevaniWithdrawStatus.FD_Withdraw_Approval_pending
          ) {
            return (
              <Tooltip title="Edit">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    if (context?.CurrentRoleId === RoleEnum.Admin) {
                      navigate(path, {
                        state: {
                          Id: id,
                          currentStatus: currentStatus,
                          RequestId: RequestId,
                          DocUrl: DocUrl,
                          TypeOfTransactionId: TypeOfTransactionId,
                          reqId: reqId,
                          finalAmtFromList: finalAmtFromList,
                          mode: "Edit",
                        },
                      });
                    }
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </Tooltip>
            );
          } // withdraw Approved
          else {
            return (
              <Tooltip title="view">
                <a
                  className="pr-3"
                  onClick={(e) => {
                    e.preventDefault();
                    if (
                      context?.CurrentRoleId === RoleEnum.Admin ||
                      RoleEnum.Member
                    ) {
                      navigate(path, {
                        state: {
                          Id: id,
                          currentStatus: currentStatus,
                          RequestId: RequestId,
                          DocUrl: DocUrl,
                          TypeOfTransactionId: TypeOfTransactionId,
                          reqId: reqId,
                          finalAmtFromList: finalAmtFromList,
                          mode: "View",
                        },
                      });
                    }
                  }}
                >
                  <i className="fas fa-eye"></i>
                </a>
              </Tooltip>
            );
          }
        },
      },
    },
    // {
    //   name: "Action",
    //   label: "Action",
    //   options: {
    //     display:
    //       activeTab.id === "Deposite-requests" ||
    //       activeTab.id === "Withdraw-requests",
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value: any, tableMeta: any) => {
    //       let id = tableMeta.rowData[0];
    //       let reqId = tableMeta.rowData[1];
    //       const currentStatus = tableMeta.rowData[2];
    //       const RequestId = tableMeta.rowData[9];
    //       const DocUrl = tableMeta.rowData[10];
    //       const TypeOfTransactionId = tableMeta.rowData[11];
    //       const isAdminOrMember =
    //         context?.CurrentRoleId === RoleEnum.Admin ||
    //         context?.CurrentRoleId === RoleEnum.Member;
    //       
    //       // Check if the current status is one of the edit statuses
    //       const isEditStatus = [
    //         SanjeevaniDepositStatus.Deposit_Approval_Pending,
    //         SanjeevaniWithdrawStatus.FD_Withdraw_Approval_pending,
    //         SuvidhaDepositStatus.SU_Deposit_Approval_pending,
    //         SuvidhaWithdrawStatus.SU_FD_Withdraw_Approval_pending,
    //       ].includes(currentStatus);

    //       return (
    //         <Tooltip title={isAdminOrMember ? "Edit" : "View"}>
    //           <a
    //             onClick={(e) => {
    //               e.preventDefault();
    //               if (isAdminOrMember && isEditStatus) {
    //                 handleNavigation(
    //                   id,
    //                   currentStatus,
    //                   RequestId,
    //                   DocUrl,
    //                   TypeOfTransactionId,
    //                   reqId
    //                 );
    //               }
    //             }}
    //           >
    //             <i
    //               className={
    //                 isAdminOrMember && isEditStatus
    //                   ? "fas fa-edit"
    //                   : "fas fa-eye"
    //               }
    //             ></i>
    //           </a>
    //         </Tooltip>
    //       );
    //     },
    //   },
    // },
  ];

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const getDashboardData = async () => {
    showLoader();

    try {
      let obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        FromDate: currentFilters?.fromDate || "",
        ToDate: currentFilters?.toDate || "",
        YojnaType:
          appModule === AppModules.SuvidhaYojna
            ? "SuvidhaYojna"
            : "SanjivaniYojna",
      };

      // Deposite requests
      if (activeTab.id === "Deposite-requests") {
        const resp = await APICall(GetSJNYAdminDepostRequestDashboard, obj);
        if (resp.Data.SNJY_DepositRequestList.length > 0) {
          setDashboardData(resp?.Data.SNJY_DepositRequestList);
          const dataCount = resp?.Data?.SNJY_DepositRequestList[0].TotalCount;
          setDataCount(dataCount ?? 0);
          hideLoader();
          // setCurrentDataReqObj(obj);
        } else {
          setDashboardData([]);
          setDataCount(0);
        }
      }
      // Withdraw-requests
      else if (activeTab.id === "Withdraw-requests") {
        const resp = await APICall(GetSJNYAdminDepostRequestDashboard, obj);
        if (resp.Data.SNJY_AdminWithdrawRequestList.length > 0) {
          setDashboardData(resp?.Data.SNJY_AdminWithdrawRequestList);
          const dataCount =
            resp?.Data?.SNJY_AdminWithdrawRequestList[0].TotalCount;
          setDataCount(dataCount ?? 0);
          hideLoader();
          // setCurrentDataReqObj(obj);
        } else {
          setDashboardData([]);
          setDataCount(0);
        }
      }
    } catch (err) {
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
    } finally {
      hideLoader();
    }
  };

  return (
    <div>
      <DynamicGrid
        options={Options}
        data={dashboardData}
        columns={GridColumns}
      />
    </div>
  );
};

export default SANReqGrid;
